import { render, staticRenderFns } from "./p01.vue?vue&type=template&id=8c5aa840&scoped=true&"
import script from "./p01.vue?vue&type=script&lang=js&"
export * from "./p01.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c5aa840",
  null
  
)

export default component.exports